var app = angular.module('leonardo');

var UsernameFilter = function () {
  return function (user) {
    if (!user) return '';
    var values = [];
    if (user.first_name) values.push(user.first_name);
    if (user.last_name) values.push(user.last_name);
    return values.join(' ');
  }
};

app.filter('username', [UsernameFilter]);
